import React, { useState, useEffect } from 'react';
import { BreadcrumbContext } from './BreadcrumbContext';
import { BreadcrumbItem } from '../utils/breadcrumbsUtilService';

export default function BreadcrumbContextProvider({ children }: { children: React.ReactNode }) {
    const [breadcrumbArray, setBreadcrumbArray] = useState<BreadcrumbItem[]>([]);

    useEffect(() => {
        // Send postMessage whenever breadcrumbArray changes
        if (breadcrumbArray.length > 0) {
            window.postMessage(
                {
                    type: 'BREADCRUMB_CHANGED',
                    data: {
                        breadcrumbs: breadcrumbArray,
                        timestamp: new Date().toISOString(),
                    },
                },
                '*',
            );
        }
    }, [breadcrumbArray]);

    return (
        <BreadcrumbContext.Provider value={{ breadcrumbArray, setBreadcrumbArray }}>
            {children}
        </BreadcrumbContext.Provider>
    );
}
